import { watch } from 'vue';
import { generateColor } from '../util';
import useState from '../../_util/hooks/useState';
function hasValue(value) {
    return value !== undefined;
}
const useColorState = (defaultStateValue, option) => {
    const { defaultValue, value: color } = option;
    const [colorValue, setColorValue] = useState(() => {
        let mergeState;
        if (hasValue(color.value)) {
            mergeState = color.value;
        }
        else if (hasValue(defaultValue)) {
            mergeState = defaultValue;
        }
        else {
            mergeState = defaultStateValue;
        }
        return generateColor(mergeState);
    });
    watch(option.value, value => {
        setColorValue(generateColor(value));
    });
    return [colorValue, setColorValue];
};
export default useColorState;
